module.exports = __webpack_public_path__ + "static/icons/sorprendido.b7ae225.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/character/sorprendido.svg
// module id = +tJy
// module chunks = 1